export default {
  trialDays: 7,
}
